/**
 * @generated SignedSource<<5fa50958061aa7aa68094b0b8f3dc3ab>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsPlanningProject_tradeFirm$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_tradeFirm">;
  readonly " $fragmentType": "TradeBenefitsPlanningProject_tradeFirm";
};
export type TradeBenefitsPlanningProject_tradeFirm$key = {
  readonly " $data"?: TradeBenefitsPlanningProject_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsPlanningProject_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsPlanningProject_tradeFirm",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_tradeFirm"
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "e98f4d3fb19fd435ff9e6f1bb30b24e3";

export default node;
